import React, { useState } from 'react';
import { Box, ToggleButtonGroup, ToggleButton, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';
import { styled } from '@mui/material/styles';
import { Palette } from '@/themes/themeOverrides/Palette';

const StyledPromotionalCampaignsTabs = styled(Box)({
    paddingTop: '40px',
    borderTop: `2px solid ${Palette.gray.gray300}`,
    display: 'flex',
    gap: '48px',
    '& .MuiToggleButtonGroup-root': {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: Palette.gray.gray100,
        borderRadius: '12px',
        border: `2px solid ${Palette.gray.gray100}`,
    },
    '& .MuiToggleButton-root': {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '-0.14px',
        textTransform: 'none',
        padding: '10px 16px',
        width: '148px',
        textAlign: 'left',
        display: 'block',
        border: 'none',
        '&.Mui-selected': {
            backgroundColor: Palette.white,
            color: Palette.black,
            fontWeight: 600,
            boxShadow: Palette.boxShadow.elevation1,
            borderTopRightRadius: '12px',
            borderBottomRightRadius: '12px',
        },
    },
    '& .MuiToggleButtonGroup-firstButton': {
        borderRadius: '12px',
    },
    '& .MuiToggleButtonGroup-lastButton': {
        borderRadius: '12px',
    },
    '& .data-list': {
        display: 'flex',
        gap: '48px',
        width: '100%',
        '& .MuiBox-root': {
            flex: 1,
        },
    },
    '& .data-list-item': {
        '& .MuiTypography-root.MuiTypography-caption': {
            fontSize: '9px',
            fontWeight: 700,
            lineHeight: '12px',
            letterSpacing: '0.36px',
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
            marginBottom: '20px',
        },
    },
    '& .data-list-item-value': {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '-0.14px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: Palette.gray.gray75,
        padding: '8px 16px',
        borderRadius: '8px',
        marginBottom: '4px',
        '&:last-of-type': {
            marginBottom: '0',
        },
        '& span': {
            fontWeight: 600,
        },
    },
});

export const PromotionalCampaignsTabs = ({ conversionData = {}, viewsData = {} }) => {
    const [selectedView, setSelectedView] = useState('conversion');
    const translate = useTranslate();

    const handleViewChange = (event, newView) => {
        if (newView !== null) {
            setSelectedView(newView);
        }
    };

    const renderDataList = (data, title) => {
        return (
            <Box className='data-list-item'>
                <Typography variant='caption' gutterBottom>
                    {title}
                </Typography>
                <Box>
                    {data.length > 0 ? (
                        data.map(item => (
                            <Box className='data-list-item-value' key={`${item.name}-${item.value}`} gutterBottom>
                                {item.name}{' '}
                                <Typography component='span' variant='inherit'>
                                    {item.value}
                                </Typography>
                            </Box>
                        ))
                    ) : (
                        <Box>
                            <Typography variant='body1' gutterBottom>
                                {translate('common.noData')}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
        );
    };

    const currentData = selectedView === 'conversion' ? conversionData : viewsData;

    return (
        <StyledPromotionalCampaignsTabs>
            <Box className='toggle-button-group'>
                <ToggleButtonGroup
                    value={selectedView}
                    exclusive
                    onChange={handleViewChange}
                    aria-label={translate('resources.campaign.labels.dataView')}
                    size='small'
                >
                    <ToggleButton value='conversion' aria-label={translate('resources.campaign.labels.conversion')}>
                        {translate('resources.campaign.labels.conversion')}
                    </ToggleButton>
                    <ToggleButton value='views' aria-label={translate('resources.campaign.labels.views')}>
                        {translate('resources.campaign.labels.views')}
                    </ToggleButton>
                </ToggleButtonGroup>
            </Box>

            <Box className='data-list'>
                <Box>{renderDataList(currentData.cities || [], translate('resources.campaign.labels.cities').toUpperCase())}</Box>
                <Box>{renderDataList(currentData.voivodeships || [], translate('resources.campaign.labels.voivodeships'))}</Box>
                <Box>{renderDataList(currentData.deviceGroups || [], translate('resources.campaign.labels.deviceGroups'))}</Box>
            </Box>
        </StyledPromotionalCampaignsTabs>
    );
};
